import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Modals/NewsletterUnsubscribeModal/newsletterUnsubscribeModal"
    ).then((module) => ({
        default: module.NewsletterUnsubscribeModal
    }))
);
